import styled from "styled-components";

import { breakpoints, colors } from "../../helpers";

export const ContentWrapper = styled.section`
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
`;
